import { http } from '@/http/http.js'

//根据id查询部门信息
export function getDeptInfo(params) {
    return http.post("/web/dept/info", params)
}
//获取负责人列表
export function getEmployee(params) {
    return http.post("/web/dept/queryEmployee", params)
}
//新增子部门
export function addNewDept(params) {
    return http.post("/web/dept/save", params)
}
//修改子部门
export function updateDept(params) {
    return http.post("/web/dept/update", params)
}

//删除子部门
export function deleteDept(params) {
    return http.post("/web/dept/delete", params)
}